module.exports = __webpack_public_path__ + "static/media/Truck.358e775a.png";